<template>
  <span>
    <singletext >{{textdataqian}}</singletext>
    <inputcomp/>
    <singletext >{{textdatahou}}</singletext>
  </span>
</template>

<script>
import inputcomp from '../components/inputcomp.vue'

import singletext from '../components/singletext.vue'

export default {
  components: { inputcomp, singletext },

  data () {
    return {
      textdataqian: '此为前一部分',
      textdatahou: '此为空后记得空后加；'
    }
  }

}
</script>
